/* ---------------------------------------------------------------------------
   at-delai.js
   « Expédié avant le <jour> <date> », calculé en +2 jours calendaires côté client.

   Pourquoi côté client : Shopify met les pages en cache, une date calculée en
   Liquid peut être servie périmée le lendemain.

   Pourquoi dans un asset et pas dans le snippet : le thème est en mode tiroir,
   et cart.js remplace l'intérieur de #CartDrawer par innerHTML à chaque
   changement de quantité. Un <script> réinjecté par innerHTML ne s'exécute
   jamais. Un client dont le panier était vide au chargement n'aurait donc
   jamais vu la date. Le fichier est chargé une seule fois, hors de la zone
   re-rendue.

   Règle, +2 jours calendaires (samedi est un jour d'expédition normal) :
     on ajoute 2 jours calendaires à aujourd'hui ; si le résultat tombe un
     dimanche ou un jour férié, on avance jour par jour jusqu'au prochain
     jour valable.
   Commande jeudi vers samedi, vendredi vers lundi, samedi vers lundi,
   lundi vers mercredi, mardi vers jeudi.

   Jours fériés : CALCULÉS, pas listés. La version précédente portait une liste
   figée qui s'arrêtait au 25/12/2027 : passé cette date elle aurait compté les
   fériés comme ouvrés et affiché une date fausse en silence, sur le fichier qui
   porte notre seule promesse forte. Les 8 dates fixes sont posées, les 3 dates
   mobiles (lundi de Pâques, Ascension, lundi de Pentecôte) viennent de
   l'algorithme de Pâques grégorien de Meeus. Valable sans limite.

   Si le JavaScript est coupé, rien ne s'affiche. C'est voulu, mieux vaut pas
   de date qu'une date fausse.

   Mesure du 18/08/2026 : 56 des 60 dernières commandes sont parties en moins
   de 48h, soit 93 %. Mesure faite sous l'ancienne règle (samedi fermé) : à
   refaire après bascule vers la règle samedi ouvert.
   --------------------------------------------------------------------------- */

(function () {
  if (window.__atDelaiExpedition) return;
  window.__atDelaiExpedition = true;

  /* Dimanche de Pâques, calendrier grégorien (Meeus, Jones, Butcher). */
  function paques(annee) {
    var a = annee % 19;
    var b = Math.floor(annee / 100);
    var c = annee % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var n = h + l - 7 * m + 114;
    return new Date(annee, Math.floor(n / 31) - 1, (n % 31) + 1, 12, 0, 0, 0);
  }

  function iso(d) {
    var m = d.getMonth() + 1;
    var j = d.getDate();
    return d.getFullYear() + '-' + (m < 10 ? '0' + m : m) + '-' + (j < 10 ? '0' + j : j);
  }

  function decale(depart, jours) {
    var d = new Date(depart.getTime());
    d.setDate(d.getDate() + jours);
    return d;
  }

  /* Les 11 jours fériés français d'une année. */
  function feries(annee) {
    var p = paques(annee);
    var liste = [
      annee + '-01-01',
      annee + '-05-01',
      annee + '-05-08',
      annee + '-07-14',
      annee + '-08-15',
      annee + '-11-01',
      annee + '-11-11',
      annee + '-12-25',
      iso(decale(p, 1)),
      iso(decale(p, 39)),
      iso(decale(p, 50))
    ];
    return liste;
  }

  var cache = {};
  function estFerie(d) {
    var annee = d.getFullYear();
    if (!cache[annee]) cache[annee] = feries(annee);
    return cache[annee].indexOf(iso(d)) !== -1;
  }

  /* Seul le dimanche (et les jours fériés) ferment l'expédition. Le samedi
     est un jour d'expédition normal. */
  function estOuvre(d) {
    var jour = d.getDay();
    if (jour === 0) return false;
    return !estFerie(d);
  }

  function dateExpedition() {
    var d = new Date();
    d.setHours(12, 0, 0, 0);
    d.setDate(d.getDate() + 2);
    var garde = 0;
    while (!estOuvre(d) && garde < 30) {
      d.setDate(d.getDate() + 1);
      garde++;
    }
    return d;
  }

  var format = null;
  try {
    format = new Intl.DateTimeFormat('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
  } catch (e) {
    format = null;
  }

  function poser() {
    if (!format) return;
    var cibles = document.querySelectorAll('[data-at-delai]:not([data-at-delai-fait])');
    if (!cibles.length) return;
    var texte = format.format(dateExpedition());
    for (var i = 0; i < cibles.length; i++) {
      var el = cibles[i];
      el.setAttribute('data-at-delai-fait', '1');
      /* Avec un préfixe la phrase se poursuit, donc minuscule : « Commandé
         aujourd'hui, expédié avant le mardi 25 août. » Sans préfixe elle
         commence, donc majuscule. */
      var prefixe = el.getAttribute('data-at-prefixe') || '';
      var phrase = 'expédié avant le ' + texte + '.';
      if (prefixe) {
        el.textContent = prefixe + phrase;
      } else {
        el.textContent = phrase.charAt(0).toUpperCase() + phrase.slice(1);
      }
      el.hidden = false;
    }
  }

  /* Le tiroir est re-rendu par cart.js à chaque changement de quantité, et la
     fiche produit re-rend <product-info> à chaque changement de variante.
     On n'observe QUE ces trois racines, pas le document entier : un
     observateur global se réveille à chaque mutation de chaque page du site.
     Le marqueur data-at-delai-fait et le regroupement par frame évitent de
     boucler sur nos propres écritures. */
  var enAttente = false;
  function planifier() {
    if (enAttente) return;
    enAttente = true;
    var suite = function () {
      enAttente = false;
      poser();
    };
    /* 07/09/2026 : setTimeout et non requestAnimationFrame. rAF ne tire pas
       tant que l'onglet ne compose pas de frame (onglet en arrière-plan, volet
       masqué), et la date du tiroir restait vide après un ajout au panier. */
    setTimeout(suite, 0);
  }

  function observer() {
    if (!window.MutationObserver) return;
    var obs = new MutationObserver(planifier);
    var racines = [
      document.getElementById('CartDrawer'),
      document.getElementById('main-cart-footer'),
      document.querySelector('product-info')
    ];
    for (var i = 0; i < racines.length; i++) {
      if (racines[i]) obs.observe(racines[i], { childList: true, subtree: true });
    }
  }

  function demarrer() {
    poser();
    observer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();